import { webRequestClient } from '@/services'
import commonActions from '@/store/data/common/actions'
import { errorHandler } from '@/utils/helpers'
import { get, isEmpty, toNumber } from 'lodash'
import helpers from './helpers'

const actions = {
    ...commonActions,
    retrieveItems({ commit, rootState }, params) {
        commit('setIsLoading', true)
        const fetchAllData = params && params.all
        const _params = fetchAllData ? { account_id: toNumber(rootState.account.accountId) } : { account_id: toNumber(rootState.account.accountId), sparsed: 1 }

        return webRequestClient
            .get('/audience_admin/accounts_second_party_clusters/hierarchy/json', {
                params: _params
            })
            .then(secondPartyData => {
                if (get(secondPartyData, 'status') === 'KO' || get(secondPartyData, 'status') === 401) {
                    errorHandler('Error while retrieving second party data', commit)
                } else {
                    if (fetchAllData) {
                        commit('setRetrievedItems', { items: helpers.parseMarketPlacePageData(secondPartyData) })
                        commit('setActiveItems', { items: helpers.parseBuilderPagedData(secondPartyData) })
                    } else {
                        commit('setActiveItems', { items: helpers.parseBuilderPagedData(secondPartyData) })
                        commit('setCollection', helpers.instanciateAll(secondPartyData))
                        commit('setActiveProviders')
                    }
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => commit('setIsLoading', false))
    },

    requestSaveActivateClusters({ commit, dispatch, rootState }, params) {
        return webRequestClient
            .post('/audience_admin/accounts_second_party_clusters/status/json', { ...params, account_id: toNumber(rootState.account.accountId) })
            .then(response => {
                if (!isEmpty(response) && get(response, 'status', '') !== 'KO') {
                    dispatch('retrieveItems', { all: true })
                    dispatch('retrieveItems')
                    commit('ui/secondParty/setResetedModifiedClusters', {}, { root: true })
                    commit('notifications/setAddedNotification', { type: 'success', message: 'Clusters successfully updated' }, { root: true })
                } else {
                    const _errorMessage = isEmpty(get(response, 'message', '')) ? 'Clusters update failed' : response.message
                    errorHandler(_errorMessage, commit)
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
    }
}

export default actions
